import React from 'react';
import PropTypes from 'prop-types';
import MediaGalleryThumbnail from '../../containers/MediaGalleryThumbnail';
import { MediaGalleryThumbnailPlaceholder } from '../MediaGalleryThumbnail';
import MediaGalleryFileInfo from '../../containers/MediaGalleryFileInfo';
import MediaGalleryActions from '../../containers/MediaGalleryActions';
import MediaGalleryTrashActions from '../../containers/MediaGalleryTrashActions';
import { EDIT, TRASH } from '../MediaGallery/constants';
import styles from './styles.scss';

const propTypes = {
  setSelectedMedium: PropTypes.func,
  selectedMedium: PropTypes.string,
  setBanners: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  updateFilter: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  facilityId: PropTypes.string,
};

const defaultProps = {
  facilityId: undefined,
  setSelectedMedium: undefined,
  selectedMedium: undefined,
};

const MediaGalleryRightPanel = (props) => {
  const {
    setSelectedMedium,
    selectedMedium,
    filter,
  } = props;

  return (
    <div>
      {selectedMedium ? (
        filter !== EDIT && (
          <MediaGalleryThumbnail
            selectedMedium={selectedMedium}
            setSelectedMedium={setSelectedMedium}
          />
        )
      ) : <MediaGalleryThumbnailPlaceholder />}
      <div className={styles.actions}>
        <div className={styles.actionHeader}>
          Actions
        </div>
        {filter === TRASH
          ? <MediaGalleryTrashActions {...props} />
          : <MediaGalleryActions {...props} filter={filter} />}
      </div>
      {selectedMedium && (
        <MediaGalleryFileInfo
          selectedMedium={selectedMedium}
          setSelectedMedium={setSelectedMedium}
        />
      )}
    </div>
  );
};

MediaGalleryRightPanel.propTypes = propTypes;
MediaGalleryRightPanel.defaultProps = defaultProps;

export default MediaGalleryRightPanel;
